import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { OnboardingWizard } from '../../onboarding/OnboardingWizard.jsx';

const SignUp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { token, currentUser } = useSelector(state => state?.auth || {});

  const {sw_payment_flag, sw_store_flag, sw_store_sync_flag, store_sync_started_at, role} = currentUser || {};

  const startedAt = new Date(store_sync_started_at).getTime();
  const thirtyMinutesAgo = Date.now() - 30 * 60 * 1000;

  useEffect(() => {
    // Stay inside the onboarding wizard when we're on the signup route
    if (location.pathname.startsWith('/auth/sign-up')) return;

    if (!token || !currentUser) return;

    if (role?.id === 5 || role?.id === 2) {
      if (sw_payment_flag && sw_store_flag && sw_store_sync_flag && startedAt < thirtyMinutesAgo) {
        navigate('/', { replace: true });
      }
      return;
    } else {
      navigate('/', { replace: true });
    }
  }, [location.pathname, token, currentUser, role, sw_payment_flag, sw_store_flag, sw_store_sync_flag, startedAt, thirtyMinutesAgo, navigate]);

  return <OnboardingWizard />;
};

export default SignUp;
